/**
 * Ручки, которые ALB отдаёт только в backoffice-api (Kotlin). 401 здесь пока не
 * означает протухшую сессию всего кабинета (часто расхождение auth с core) — не роняем login.
 */
const BACKOFFICE_KOTLIN_ONLY_PATHS = [
    /^\/api\/admin\/transaction\/[^/]+\/gate-logs$/,
]

function requestPath (rawUrl) {
    const withoutQuery = (rawUrl || '').replace(/\?.*$/, '')
    if (withoutQuery.startsWith('http')) {
        try {
            return new URL(withoutQuery).pathname
        } catch (e) {
            return withoutQuery
        }
    }
    return withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`
}

export function shouldLogoutOnUnauthorized (error) {
    if (!error?.response || error.response.status !== 401) {
        return false
    }
    const path = requestPath(error.config?.url)
    if (BACKOFFICE_KOTLIN_ONLY_PATHS.some((re) => re.test(path))) {
        return false
    }
    return true
}
